import { HTMLAttributes } from 'react';
import DOMPurify, { Config } from 'dompurify';

interface PlainHtmlContainerProps extends HTMLAttributes<HTMLDivElement> {
  content: string;
  config?: Config;
}

export const PlainHtmlContainer = ({
  content,
  config = {},
  ...rest
}: PlainHtmlContainerProps) => {
  const cleanContent = DOMPurify.sanitize(content, config);

  return <div {...rest} dangerouslySetInnerHTML={{ __html: cleanContent }} />;
};
